import { getTableData, getCanDownload, getCanDownloadDetail } from '@/axios/api/activityLog'
// import { Message } from 'element-ui'

const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const RESET_SEARCH = 'RESET_SEARCH'

const state = {
  tableData: [],
  tblLoading: false,
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  params: {
    activityType: undefined,
    userId: undefined,
    userName: undefined,
    userAccount: undefined,
    action: undefined,
    content: undefined,
    startTime: undefined,
    endTime: undefined,
    module: undefined
  }
}
const getters = {
  tableData: state => state.tableData,
  tblLoading: state => state.tblLoading,
  pager: state => state.pager,
  params: state => state.params
}

const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = { ...state.pager, ...pager }
    if (params) state.params = params
  },
  [RESET_SEARCH] (state) {
    state.params = {
      activityType: undefined,
      userId: undefined,
      userName: undefined,
      userAccount: undefined,
      action: undefined,
      content: undefined,
      startTime: undefined,
      endTime: undefined,
      module: undefined }
  }
}

const actions = {
  // 获取列表数据
  async getTableDataApi ({ commit }, params) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      let { data: res } = await getTableData(params)
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) { }
    commit(UPDATE_TBL_LOADING, false)
  },
  // 设置page
  setPagerApi ({ commit }, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  changeLoadingApi ({ commit }, flag) {
    commit(UPDATE_TBL_LOADING, flag)
  },
  // 判断是否可以下载
  async getCanDownloadApi ({ commit }, params) {
    try {
      let { data: res } = await getCanDownload(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 详情页判断是否可以下载
  async getCanDownloadDetailApi ({ commit }, params) {
    try {
      let { data: res } = await getCanDownloadDetail(params)
      return res
    } catch (e) {
      return false
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/activityLog.js